import { memo } from "react";
import { cn } from "utils";
import { About } from "../../topproject/columns/About";
import NextImage from "@/src/components/NextImage";
import type { StockType } from "@/src/utils/stockType";

interface StockTokenProps {
  logo: string;
  symbol: string;
  companyName: string;
  tag?: string;
  className?: string;
  /**
   * 股票市场类型：US | HK
   * 由上层列表（如 StockThemeTable）传入
   */
  market?: StockType;
  shortName?: string;
}
const StockTokenOrg = (props: StockTokenProps) => {
  const { logo, symbol, companyName, shortName, className, market } = props;

  return (
    <div className="flex flex-row items-center gap-2">
      <NextImage
        src={logo}
        alt={symbol}
        width={24}
        height={24}
        className="rounded-full border-solid border-border_solid border-[1.25px]"
      />
      <div className="flex flex-col">
        <div className="flex flex-row gap-1 items-center">
          <span className="body_medium_m text-content_primary">
            {shortName || symbol}
          </span>
          {/* {tag && (
            <div className="border-solid border-border_white_transparent20 border-[0.75px] px-1 py-0.5 rounded-1 items-center flex">
              <span className=" body_bold_xs  text-content_secondary">
                {tag}
              </span>
            </div>
          )} */}
        </div>
        <About
          desc={market === "HK" ? symbol : companyName}
          descTooltipText={companyName}
          className={cn(
            "body_s text-content_tertiary break-words truncate",
            className,
          )}
          rootClassName="max-w-[440px]"
        />
      </div>
    </div>
  );
};

export const StockToken = memo(StockTokenOrg);
